import React from "react";
import Grid from "@material-ui/core/Grid";
import {Button} from "primereact/button";
import {DataTable} from "primereact/datatable";
import Paper from "@material-ui/core/Paper";
import LinearProgress from "@material-ui/core/LinearProgress";
import {Dropdown} from "primereact/dropdown";
import {InputText} from "primereact/inputtext";
import NumberFormat from "react-number-format";
import {Dialog} from "primereact/dialog";
import HeaderScreenPresval from "../../components/headerScreenPresval";
import SubtitleLabel from "../../app/Title/SubtitleLabel/SubtitleLabelView";

const AforoView = (props) => {
    return (
        <React.Fragment>
            <LinearProgress color="secondary" id="LinearProgressBar" hidden={!props.isLoading}/>
            {props.messagesGrowl}
            <Paper elevation={5}
                   style={{paddingTop: '1%', paddingBottom: '2%', paddingLeft: '2%', paddingRight: '2%'}}>
                <Grid container spacing={1}>
                    <Grid item xs={12}>
                        {props.messagesGrowl}
                        <HeaderScreenPresval headerTitle={props.isReport ?
                            "Reportes \\ Históricos \\ Consulta de Aforo" :
                            "Mantenimientos \\ Aforos"}
                                             onExpand={props.clearFilters}
                                             actionSearch={props.getDataAforos}
                                             isExpanded={props.isReport}
                                             disabledSearchButton = {props.disabledSearchButton}
                        >
                            <div className="p-grid">
                                <div className="p-col-12 p-md-3 p-col-3">
                                    <SubtitleLabel header="Tipos de Aforos" isBold={true}/>
                                    <Dropdown name="typeObj"
                                              options={props.aforos}
                                              filterBy="tipoAforo"
                                              optionLabel="tipoAforo"
                                              onChange={props.onChangeFilters}
                                              value={props.filters.typeObj}/>
                                </div>
                                <div className="p-col-12 p-md-3 p-col-3">
                                    <SubtitleLabel header="Emisora a prestar" isBold={true}/>
                                    <Dropdown name="instrumentObj"
                                              options={props.instrumentsLend}
                                              filterBy="emisoraPrestamo"
                                              optionLabel="emisoraPrestamo"
                                              onChange={props.onChangeFilters}
                                              value={props.filters.instrumentObj}/>
                                </div>
                                <div className="p-col-12 p-md-3 p-col-3">
                                    <SubtitleLabel header="Garantía" isBold={true}/>
                                    <Dropdown name="guaranteeObj"
                                              options={props.guarantees}
                                              filterBy="emisoraGarantia"
                                              optionLabel="emisoraGarantia"
                                              onChange={props.onChangeFilters}
                                              value={props.filters.guaranteeObj}/>
                                </div>
                                <div className="p-col-12 p-md-3 p-col-3">
                                    <Button label="Limpiar"
                                            style={{'float': 'right'}}
                                            onClick={props.clearFilters}
                                            className="p-button-secondary"/>
                                </div>
                                <div className="p-col-12 p-md-3 p-col-3">
                                    <SubtitleLabel header="Llamada de Margen" isBold={true}/>
                                    <SubtitleLabel header={props.filters.call} />
                                </div>
                                <div className="p-col-12 p-md-3 p-col-3">
                                </div>
                            </div>
                        </HeaderScreenPresval>
                    </Grid>

                    <Grid item xs={12}>
                        <DataTable
                            ref={props.indexTable}
                            paginator={true}
                            lazy={true}
                            onPage={props.onPage}
                            totalRecords={props.totalRecords}
                            first={props.first}
                            rows={props.rows}

                            value={props.dataAforos}
                            style={{width: '100%'}}
                            selection={"single"}
                            resizableColumns={true}
                            columnResizeMode={"fit"}>
                            {props.columns}
                        </DataTable>
                    </Grid>
                    {props.confMsg}
                </Grid>
            </Paper>
            <Dialog visible={props.displayDialog} header={props.dialogHeader} modal={true}
                    onHide={props.onHideDialog} closable={false}>
                <Grid container direction="row" justify="space-evenly">
                    <Grid item xs={4}>
                        <SubtitleLabel header="Tipo de Aforo" isBold={true}/>
                        <SubtitleLabel header={props.aforoSelected.tipoAforo} />
                    </Grid>
                    <Grid item xs={4}>
                        <SubtitleLabel header="Emisora a Prestar" isBold={true}/>
                        <SubtitleLabel header={props.aforoSelected.emisoraPrestamo} />
                    </Grid>
                    <Grid item xs={4}>
                        <SubtitleLabel header="Garantía" isBold={true}/>
                        <SubtitleLabel header={props.aforoSelected.emisoraGarantia} />
                    </Grid>
                    <Grid item xs={6}>
                        <SubtitleLabel header="Porcentaje Requerido" isBold={true}/>
                        <NumberFormat decimalScale={2}
                                      id={4}
                                      fixedDecimalScale={true}
                                      name="porcAforo"
                                      placeholder="Ex: 999.00"
                                      value={props.aforoSelected.porcAforo}
                                      onChange={props.onChangeInput}
                                      customInput={InputText}/>
                    </Grid>
                    <Grid item xs={6}/>
                </Grid>
            </Dialog>
        </React.Fragment>
    )
};

export default AforoView;